import React from "react";
import { Avatar } from "@chakra-ui/react";
import { useUser } from "contexts/UserContext";

/**
 * Reusable UserAvatar component.
 * Reads from global UserContext:
 *   - Shows avatar image if user.avatar is set
 *   - Falls back to Chakra's initial-based avatar otherwise
 */
export default function UserAvatar({ size = "sm", w = "40px", h = "40px", ...rest }) {
  const { user } = useUser();
  const avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(user?.name || "User")}&background=6C63FF&color=fff`;

  return (
    <Avatar
      name={user?.name || "User"}
      src={user?.avatar || avatarUrl}
      size={size}
      w={w}
      h={h}
      objectFit="cover"
      {...rest}
    />
  );
}
